<template>
  <SettingSection
    title="Расходы"
    icon-variant="expenses"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";

export default {
  name: "ExpensesSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <line x1="12" y1="1" x2="12" y2="23"></line>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
      `,
      links: [
        {
          label: "Категории расходов",
          route: { name: "ExpenseCategories" },
        },
        {
          label: "Источники оплаты",
          route: { name: "PaymentSources" },
        },
      ],
    };
  },
};
</script>
